<!-- 业主结算 -->
<template>
    <div class="container containerBox">
        <div>
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark">
                <el-table-column
                    prop="household_name"
                    label="业主"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="house_name"
                    label="房间号"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="house_area"
                    label="房屋面积"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="house_basic_cost"
                    label="房间基础花费"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="house_rate"
                    label="房间面积单价"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="is_paied"
                    label="缴费状态"
                    show-overflow-tooltip>
					<template slot-scope="scope">
					    <el-tag :type="scope.row.is_paied? 'success': 'danger'">{{scope.row.is_paied?"已缴费":"未缴费"}}</el-tag>
					</template>
                </el-table-column>
                <el-table-column
                    prop="last_settlement_time"
                    label="账单开始时间"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="settlement_time"
                    label="账单结束时间"
                    show-overflow-tooltip>
                </el-table-column>
				<el-table-column
				    prop="terminal_cost"
				    label="表计花费"
				    show-overflow-tooltip>
				</el-table-column>
                <el-table-column
                    prop="real_cost"
                    label="实际花费"
                    show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="sum_cost"
                    label="总花费"
                    show-overflow-tooltip>
                </el-table-column>
                
				<el-table-column label="操作">
				  <template slot-scope="scope">
					<el-button
					  size="mini"
					  type="primary"
					  @click="onSubmit(scope.row)">缴费</el-button>
				  </template>
				</el-table-column>
            </el-table>
        </div>
<!--        <div class="handle-box">
            <div class="container-title">用户基本信息</div>
            <el-form :inline="true" :model="handleForm" class="demo-form-inline">
                <el-form-item label="用户编号">
                    <el-input v-model="handleForm.number" placeholder="请输入用户编号"></el-input>
                </el-form-item>
                <el-form-item label="住宅面积">
                    <el-input v-model="handleForm.number" placeholder="请输入住宅面积"></el-input>
                </el-form-item>
                <el-form-item label="基本费单价">
                    <el-input v-model="handleForm.number" placeholder="请输入基本费单价"></el-input>
                </el-form-item>
                <el-form-item label="基本费用">
                    <el-input v-model="handleForm.number" placeholder="请输入基本费用"></el-input>
                </el-form-item>
                <el-form-item label="业主名称">
                    <el-input v-model="handleForm.number" placeholder="请输入业主名称"></el-input>
                </el-form-item>
                <el-form-item label="上次抄表">
                    <el-input v-model="handleForm.number" placeholder="请输入上次抄表"></el-input>
                </el-form-item>
                <el-form-item label="本次抄表">
                    <el-input v-model="handleForm.number" placeholder="请输入本次抄表"></el-input>
                </el-form-item>
                <el-form-item label="总金额">
                    <el-input v-model="handleForm.number" placeholder="请输入总金额"></el-input>
                </el-form-item>
                <el-form-item label="用户地址">
                    <el-input v-model="handleForm.number" placeholder="请输入用户地址"></el-input>
                </el-form-item>
                <el-form-item label="折扣率">
                    <el-input v-model="handleForm.number" placeholder="请输入折扣率"></el-input>
                </el-form-item>
                <el-form-item label="实际金额">
                    <el-input v-model="handleForm.number" placeholder="请输入实际金额"></el-input>
                </el-form-item>
                <div style="text-align:center;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">确认结算</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div> -->
    </div>
</template>

<script>
import Service from '@/api/Service'
export default {
  name:'clearingdetail',
  data () {
    return {
        // 用户基本信息
        handleForm:{},
        // 表计数据
        tableData:[],
		pay_status:0,
		page_num: 1,
		page_sum: 100,
    };
  },
	created() {
		this.handleForm =JSON.parse(decodeURIComponent(this.$route.query.data)) 
		this.housebill(this.handleForm)
		
	},
	methods: {
		//获取账单
		async housebill(){
			let params={}
			params.ids = JSON.stringify([{oid: this.handleForm.oid}])
			params.household_name = this.handleForm.name
			params.from = this.handleForm.from;
			params.to = this.handleForm.to;
			params.is_house =this.handleForm.is_house;
			params.pay_status = this.pay_status;
			params.page_num = this.page_num;
			params.page_sum = this.page_sum;
			let res = await Service.getHouseBill(params)
			if(res){
				this.tableData =res.list || []
			}
		},
		// 缴费
		async onSubmit(row) {
			let res = await Service.PayFor({bill_house_id:row.oid})
			if(res){
				this.housebill(this.handleForm)
			}
		},
		handleSelectionChange() {},
		}
}

</script>
<style lang='css' scoped>
</style>